<script setup lang="ts">
import { PhSparkle } from "@phosphor-icons/vue";
</script>

<template>
  <div id="analysisSection" class="smart-filter" aria-label="智能筛选" hidden>
    <button id="analysisButton" class="analysis-button" type="button" disabled>
      <PhSparkle class="smart-filter-icon" :size="14" weight="fill" aria-hidden="true" />
      <span class="button-progress" aria-hidden="true"></span>
      <span id="analysisButtonLabel">智能筛选</span>
    </button>
  </div>
</template>
